const baseStyle = {
  borderRadius: 'md',
};

const defaultProps = {
  variant: 'ghost',
  size: 'md',
};

const sizes = {
  lg: {
    p: 3,
  },
  md: {
    p: 2,
  },
  sm: {
    p: 1,
  },
};

export default {
  baseStyle,
  sizes,
  defaultProps,
};
